<template>
  <div class="forgot-password">
    <div class="layout">
      <h1 class="text-center mb-2">
        <img src="@/assets/images/ilogo.png" alt />
      </h1>
      <el-card shadow="hover">
        <div class="content">
          <div class="desc">
            <h3 class="text-center">{{$t('auth.verifyEmail.title')}}</h3>
            <p
              class="text-center"
              v-if="userInfo"
              v-html="$t('auth.verifyEmail.notice', {email: userInfo.email})"
            ></p>
            <el-button
              type="primary"
              class="w-100 mb-0"
              :disabled="isResendEmail"
              @click="!isResendEmail ? handleResendEmailConfirm() : null"
            >
              {{$t('auth.verifyEmail.resend')}}
              <i class="el-icon-loading" v-if="isResendEmail"></i>
            </el-button>
            <a
              href
              @click="goBackLogin"
              class="text-primary text-center d-block mt-1"
            >{{$t('auth.verifyEmail.loginLink')}}</a>
          </div>
          <img src="@/assets/images/verify-email.jpg" alt />
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import authServices from '@/services/auth'
export default {
  name: 'VerifyEmail',
  data () {
    return {
      isResendEmail: false
    }
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  methods: {
    handleResendEmailConfirm () {
      this.isResendEmail = true
      authServices.resendEmail()
        .then(res => {
          this.isResendEmail = false
          this.$notify({
            message: this.$t('auth.verifyEmail.notify'),
            showClose: false,
            duration: 3000,
            customClass: 'success'
          })
          setTimeout(() => {
            this.$router.push({
              name: 'login'
            })
          }, 1000)
        })
        .catch(e => {
          this.isResendEmail = false
          console.log(e)
          let msg = ''
          if (e.response.data && e.response.data.message) {
            msg = e.response.data.message
          }
          this.$notify({
            message: msg,
            showClose: false,
            duration: 3000,
            customClass: 'error'
          })
        })
    },
    goBackLogin () {
      this.$router.push({name: 'login'})
    }
  }
}
</script>

<style lang="scss" scoped>
.forgot-password {
  width: 100%;
  height: 100vh;
  background: #f8f8f8;
  display: flex;
  align-items: center;
  justify-content: center;
  .el-card {
    width: 800px;
    margin: 0 auto;
    padding: 20px 0;
    border-radius: 20px;
    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .form {
        width: 60%;
      }
      img {
        width: 40%;
      }
    }
  }
}
@media (max-width: 767px) {
  .forgot-password {
    padding: 20px;
    .layout {
      width: 100%;
      .el-card {
        width: 100%;
      }
    }
  }
}
@media (max-width: 480px) {
  .forgot-password {
    padding: 20px;
    .layout {
      .el-card {
        .desc {
          width: 100%;
        }
        img {
          display: none;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/auth/verify-email.vue